import { useState } from "react";
import { Link } from "react-router-dom";
import { faqs } from "@/mocks/content";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="bg-background-50">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-[1fr_1.6fr] lg:gap-16">
        <div>
          <p className="text-xs font-bold tracking-[0.25em] text-primary-600">常见问题</p>
          <h2 className="mt-2 font-display text-3xl font-black leading-tight text-foreground-950">
            吃瓜之前，
            <br />
            你可能想知道的
          </h2>
          <p className="mt-5 text-base leading-relaxed text-foreground-600">
            关于我们怎么做内容、信息来源、边界与纠错机制，都在这里。若还有疑问，欢迎通过页尾邮箱直接来信。
          </p>
          <Link
            to="/about"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
          >
            去关于页看看 <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((item, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className={
                  "overflow-hidden rounded-xl border transition-colors " +
                  (isOpen ? "border-primary-300 bg-background-100/60" : "border-background-300/70 bg-background-100/40")
                }
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <h3 className="font-display text-base font-bold text-foreground-900 md:text-lg">
                    {item.q}
                  </h3>
                  <span
                    className={
                      "flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors " +
                      (isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700")
                    }
                  >
                    <i
                      className={"ri-add-line transition-transform " + (isOpen ? "rotate-45" : "")}
                      aria-hidden="true"
                    />
                  </span>
                </button>
                {isOpen && (
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{item.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}